<template>
  <div class="pz-spinner" :class="isErrorHideLoading?'d-none':''">
    <span
      class
      :class="{
        'pz-spinner__fixed': displayType === 'fixed',
        'pz-spinner__inline': displayType === 'inline',
      }"
    >
      <span class="pz-spinner__spins pz-spinner__spins--small">
        <span class="spin"></span>
        <span class="spin"></span>
        <span class="spin"></span>
      </span>
      <span class="pz-spinner__text" v-if="text">加载中 ...</span>
    </span>
    <div :class="`pz-spinner__overlay${questionClass}`" v-if="displayType === 'fixed'"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Spinner',
  props: {
    text: String,
    questionClass: {
      type: String,
      default: () => '',
    },
    displayType: {
      type: String,
      default: () => 'inline',
    },
  },

  computed: {
    ...mapGetters({
      isErrorHideLoading: 'isErrorHideLoading',
    }),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pz-spinner {
  background-color: transparent;
  text-align: center;
  padding-top: 5%;

  $pzSpinner: &;

  &__text {
    font-size: 1rem;
    padding: 0.5rem 0;
    display: block;
  }

  &__overlay {
    background-color: #ffffff;
    opacity: 0.9;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10000;
    height: 100%;
    width: 100%;
  }

  &__overlayquestion {
    background-color: #ffffff;
    opacity: 0.9;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10000;
    height: 100%;
    width: 100%;
  }

  &__spins {
    display: inline-block;
    position: relative;
    width: 90px;
    height: 90px;
    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      border: 8px solid #dcdee1;
      border-radius: 50%;
      z-index: 1;
    }

    .spin {
      display: block;
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      border: 8px solid #17b3a3;
      border-radius: 50%;
      animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #17b3a3 transparent transparent transparent;

      &:nth-child(1) {
        animation-delay: -0.45s;
      }
      &:nth-child(2) {
        animation-delay: -0.3s;
      }
      &:nth-child(3) {
        animation-delay: -0.15s;
      }
    }

    &--small {
      width: 50px;
      height: 50px;

      &::after {
        border-width: 6px;
      }

      .spin {
        border-width: 6px;
      }
    }

    &--large {
      width: 100px;
      height: 150px;

      &::after {
        border-width: 12px;
      }

      .spin {
        border-width: 12px;
      }
    }
  }

  &__fixed {
    position: fixed;
    left: 0;
    top: 50%;
    z-index: 10001;
    width: 100%;
    text-align: center;
    transform: translateY(-50%);

    #{$pzSpinner}__text {
      font-size: 18px;
      color: #6c757d;
    }
  }

  &__inline {
    display: inline-block;
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading_wrapper {
  width: 100%;
  min-height: 100px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
